export function getAuthToken(data) {
  if (!data || typeof data !== "object") return null;
  return data.token || data.accessToken || data.access_token || null;
}

export function getAuthRoles(data) {
  if (!data || typeof data !== "object") return [];
  if (Array.isArray(data.roles)) return data.roles;
  if (data.role) return [data.role];
  return [];
}

export function getAuthPayload(data) {
  return data && typeof data === "object" ? data : {};
}

export function isAuthenticatedResponse(data) {
  return !!getAuthToken(data);
}

export function isOtpRequired(data) {
  if (!data) return false;
  if (isAuthenticatedResponse(data)) return false;

  if (typeof data === "string") {
    return /otp|رمز|تحقق|verification/i.test(data);
  }

  if (
    data.requiresOtp === true ||
    data.isOtpRequired === true ||
    data.otpRequired === true ||
    data.otpSent === true ||
    data.requiresTwoFactor === true
  ) {
    return true;
  }

  const message = data.message || data.otpMessage || "";
  if (typeof message === "string" && /otp|رمز|تحقق|verification/i.test(message)) {
    return true;
  }

  return false;
}

export function buildOtpArabicMessage(data, email = "") {
  const phone =
    data?.phoneNumber ||
    data?.maskedPhoneNumber ||
    data?.maskedPhone ||
    data?.phone;

  if (phone) {
    return `تم إرسال رمز التحقق إلى الرقم ${phone}`;
  }

  if (typeof data === "string") {
    return data;
  }

  if (email) {
    return `تم إرسال رمز التحقق المرتبط بالحساب ${email}`;
  }

  return (
    data?.message ||
    data?.otpMessage ||
    "تم إرسال رمز التحقق إلى رقم هاتفك المسجل"
  );
}
